import { BListGroup } from './list-group';
import { BListGroupItem } from './list-group-item';
import { pluginFactory } from '../../utils/plugins';
var ListGroupPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BListGroup: BListGroup,
    BListGroupItem: BListGroupItem
  }
});
export { ListGroupPlugin, BListGroup, BListGroupItem };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/list-group/index.js
// module id = pGjg
// module chunks = 3